import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { decrypt, encrypt } from "../utils/cryptoUtils";
import { payouthistry } from "../redux/InitiatepayoutSlice";
import { makeAuthenticatedRequest } from "../utils/api";
import {
  faBars,
  faSearch,
  faBell,
  faUserCircle,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Payout = ({ isSidebarCollapsed, isMobile }) => {
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const limit = 15;
  const offset = (currentPage - 1) * limit;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const merchantData = useSelector((state) => state.Initiatepayout.payoutlist);

  const users = JSON.parse(sessionStorage.getItem("users"));
  const user_id = users?.userdatils?.kycs_step ? users.userdatils.user_id : "0";

  const fetchData = async () => {
    try {
      const requestData = JSON.stringify({
        Dname: "flipopay_payouts",
        Tname: "payout",
        Cname: [
          "mid",
          "payout_id",
          "payout_reference",
          "account_number",
          "account_ifsc",
          "bankname",
          "requesttype",
          "beneficiary_name",
          "beneficiary_email",
          "beneficiary_mobile",
          "beneficiary_location",
          "amount",
          "open_balance",
          "close_balance",
          "transaction_reference",
          "response",
          "status",
          "credited_at",
          "created_at",
        ],
        Where: [
          {
            column: "mid",
            operator: "=",
            value: user_id,
          },
        ],
        Order: { id: "desc" },
        Search: searchTerm,
        Limit: `${limit}`,
        Offset: `${offset}`,
      });

      const encrypted = encrypt(requestData);
      const data = await makeAuthenticatedRequest("POST", "/fetch", {
        encrypted,
      });
      const decryptdata = decrypt(data);
      const fixedString = decryptdata.replace(/\\"/g, '"');
      const jsonArray = JSON.parse(fixedString);
      setTotalCount(jsonArray[0].TotalCount);
      dispatch(payouthistry(jsonArray));
    } catch (err) {
      setError(
        "Failed to fetch data: " + (err.response?.data?.message || err.message)
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, [searchTerm, currentPage]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when new search happens
  };

  const goToNextPage = () => setCurrentPage((prev) => prev + 1);
  const goToPrevPage = () =>
    setCurrentPage((prev) => (prev > 1 ? prev - 1 : 1));

  const totalPages = Math.ceil(totalCount / limit); // Calculate total pages

  const lastpayouts =
    merchantData && merchantData.length > 0 ? merchantData : [];

  return (
    <div className={`bg-[#F4F5FA] min-h-screen`}>
      {/* Header & Sidebar */}
      {/* <Header
        toggleSidebar={toggleSidebar}
        isSidebarCollapsed={isSidebarCollapsed}
      />
      <Sidebar
        isSidebarCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
      /> */}

      <main className="main-content">
        <div
          className={`mx-auto p-4 md:p-4 transition-all duration-300 ${
            isSidebarCollapsed && !isMobile
              ? "lg:ml-20"
              : !isSidebarCollapsed && !isMobile
              ? "lg:ml-[270px]"
              : "ml-0"
          }`}
        >
          {/* Main Content */}
         <div className="mb-6 flex flex-wrap items-center justify-between ml-4">
                     <div>
                       <h2 className="text-xl font-semibold text-gray-800">Payouts</h2>
                       {/* <p className="text-sm text-gray-600 mt-1">Manage your account payouts and transactions</p> */}
                     </div>
                     <nav>
                       <ol className="flex items-center space-x-2 text-sm">
                         <li>
                           <Link
                             className="flex items-center text-gray-500 hover:text-[#299F1F] transition-colors"
                             to="/dashboard"
                           >
                             <svg
                               xmlns="http://www.w3.org/2000/svg"
                               className="h-4 w-4 mr-1"
                               fill="none"
                               viewBox="0 0 24 24"
                               stroke="currentColor"
                             >
                               <path
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 strokeWidth={2}
                                 d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                               />
                             </svg>
                             Home
                           </Link>
                         </li>
                         <li className="text-gray-400">/</li>
                         <li className="font-medium text-gray-800">Payouts</li>
                       </ol>
                     </nav>
                   </div>

          {/* Main content goes here */}

          {/* Search Bar & Pagination */}
          <div className="flex flex-col sm:flex-row justify-between items-center bg-white p-4 mt-8 rounded-xl shadow-md">
            {/* Search Bar */}
            <div className="flex items-center bg-gray-100 border border-gray-300 rounded-full px-4 py-2 w-full sm:w-80 mb-4 sm:mb-0">
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className="text-gray-500 mr-2"
              />
              <input
                type="text"
                placeholder="Search Keyword"
                className="bg-transparent outline-none w-full text-gray-800 placeholder-gray-500"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </div>

            {/* Pagination */}
            <div className="flex items-center space-x-3">
              <button
                onClick={goToPrevPage}
                className="px-3 py-1 rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 transition duration-150"
                disabled={currentPage === 1}
              >
                &lt;
              </button>

              <span className="text-sm font-medium text-gray-700">
                Page <span className="font-bold">{currentPage}</span> of{" "}
                <span className="font-bold">
                  {Math.ceil(totalCount / limit)}
                </span>
              </span>

              <button
                onClick={goToNextPage}
                className="px-3 py-1 rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 transition duration-150"
                disabled={currentPage === Math.ceil(totalCount / limit)}
              >
                &gt;
              </button>
            </div>
          </div>

          <div class="mx-auto md:py-4">
            {/* <!-- Breadcrumb Start --> */}
            <div class="space-y-5 sm:space-y-6">
              <div class="rounded-2xl border border-gray-200 bg-white">
                <div class="px-5 py-4 sm:px-6 sm:py-5">
                  <h3 class="text-base font-medium text-gray-800"></h3>
                </div>
                <div class="p-5 border-t border-gray-100 sm:p-6">
                  {/* <!-- Table Start -->
                    <!-- Add your table content here -->
                    <!-- body Content -->
                    <!-- Body content End --> */}

                  <div class="overflow-hidden rounded-xl border border-gray-200 bg-white">
                    <div class="max-w-full overflow-x-auto">
                      <table class="min-w-full">
                        {/* <!-- table header start --> */}
                        <thead>
                          <tr class="border-b border-gray-100  whitespace-nowrap text-center">
                            <th class="px-5 py-3 sm:px-6">
                              <div class="flex items-center">
                                <p class="font-medium text-black text-sm ">
                                  SI.No
                                </p>
                              </div>
                            </th>
                            <th class="px-5 py-3 sm:px-6">
                              <div class="flex items-center">
                                <p class="font-medium text-black text-sm ">
                                  Created On
                                </p>
                              </div>
                            </th>
                            <th class="px-5 py-3 sm:px-6">
                              <div class="flex items-center">
                                <p class="font-medium text-black text-sm ">
                                  UTR
                                </p>
                              </div>
                            </th>
                            <th class="px-5 py-3 sm:px-6">
                              <div class="flex items-center">
                                <p class="font-medium text-black text-sm ">
                                  Payout ID
                                </p>
                              </div>
                            </th>
                            <th class="px-5 py-3 sm:px-6">
                              <div class="flex items-center">
                                <p class="font-medium text-black text-sm ">
                                  Amount
                                </p>
                              </div>
                            </th>
                            <th class="px-5 py-3 sm:px-6">
                              <div class="flex items-center">
                                <p class="font-medium text-black text-sm ">
                                  Open Balance
                                </p>
                              </div>
                            </th>

                            <th class="px-5 py-3 sm:px-6">
                              <div class="flex items-center">
                                <p class="font-medium text-black text-sm ">
                                  Close Balance
                                </p>
                              </div>
                            </th>

                            <th class="px-5 py-3 sm:px-6">
                              <div class="flex items-center">
                                <p class="font-medium text-black text-sm ">
                                  Beneficiary Name
                                </p>
                              </div>
                            </th>

                            <th class="px-5 py-3 sm:px-6">
                              <div class="flex items-center">
                                <p class="font-medium text-black text-sm ">
                                  Status
                                </p>
                              </div>
                            </th>

                            <th class="px-5 py-3 sm:px-6">
                              <div class="flex items-center">
                                <p class="font-medium text-black text-sm ">
                                  Request Type
                                </p>
                              </div>
                            </th>

                            <th class="px-5 py-3 sm:px-6">
                              <div class="flex items-center">
                                <p class="font-medium text-black text-sm ">
                                  Account Number
                                </p>
                              </div>
                            </th>

                            <th class="px-5 py-3 sm:px-6">
                              <div class="flex items-center">
                                <p class="font-medium text-black text-sm ">
                                  Account IFSC
                                </p>
                              </div>
                            </th>

                            <th class="px-5 py-3 sm:px-6">
                              <div class="flex items-center">
                                <p class="font-medium text-black text-sm ">
                                  Bank Name
                                </p>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        {/* <!-- table header end -->
                        <!-- table body start --> */}
                        <tbody class="divide-y divide-gray-100">
                          {lastpayouts.slice(1).length > 0 ? (
                            lastpayouts.slice(1).map((fund, index) => (
                              <tr class="whitespace-nowrap text-center">
                                {/* <!-- SiNo--> */}
                                <td class="px-5 py-4 sm:px-6">
                                  <div class="flex items-center">
                                    <p class="text-gray-500 text-sm ">
                                      {index + 1}
                                    </p>
                                  </div>
                                </td>
                                {/* <!-- Create ON--> */}
                                <td class="px-5 py-4 sm:px-6">
                                  <div class="flex items-center">
                                    <p class="text-gray-500 text-sm ">
                                      {new Date(
                                        fund.created_at
                                      ).toDateString() ===
                                      new Date().toDateString()
                                        ? `Today, ${new Date(
                                            fund.created_at
                                          ).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                          })}`
                                        : `${new Date(
                                            fund.created_at
                                          ).toLocaleDateString()}, ${new Date(
                                            fund.created_at
                                          ).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                          })}`}
                                    </p>
                                  </div>
                                </td>
                               


                                {/* <!--Order ID--> */}
                                <td class="px-5 py-4 sm:px-6">
                                  <div class="flex items-center">
                                    <p class="text-gray-500 text-sm ">
                                      {fund.transaction_reference}
                                    </p>
                                  </div>
                                </td>

                                {/* <!--Reference--> */}
                                <td class="px-5 py-4 sm:px-6">
                                  <div class="flex items-center">
                                    <p class="text-gray-500 text-sm ">
                                      {fund.payout_id}
                                    </p>
                                  </div>
                                </td>

                                {/* <!--Amount--> */}
                                <td class="px-5 py-4 sm:px-6">
                                  <div class="flex items-center">
                                    <p class="text-gray-500 text-sm ">
                                      ₹ {fund.amount}
                                    </p>
                                  </div>
                                </td>

                                {/* <!--Name--> */}
                                <td class="px-5 py-4 sm:px-6">
                                  <div class="flex items-center">
                                    <p class="text-gray-500 text-sm ">
                                      ₹ {fund.open_balance}
                                    </p>
                                  </div>
                                </td>

                                {/* <!--UPI Id--> */}
                                <td class="px-5 py-4 sm:px-6">
                                  <div class="flex items-center">
                                    <p class="text-gray-500 text-sm ">
                                      ₹ {fund.close_balance}
                                    </p>
                                  </div>
                                </td>

                                {/* <!--UPI Id--> */}
                                <td class="px-5 py-4 sm:px-6">
                                  <div class="flex items-center">
                                    <p class="text-gray-500 text-sm ">
                                      {fund.beneficiary_name}
                                    </p>
                                  </div>
                                </td>

                                {/* <!--Status--> */}
                                <td className="px-5 py-4 sm:px-6">
                                  <div className="flex items-center">
                                    <p
                                      className={`
                                          ${
                                            fund.response === "PROCESSED"
                                              ? "bg-green-100 text-green-700"
                                              : fund.response === "FAILED"
                                              ? "bg-red-100 text-red-700"
                                              : fund.response === "PENDING"
                                              ? "bg-yellow-100 text-yellow-700"
                                              : fund.response === "REFUNDED"
                                              ? "bg-purple-100 text-purple-700"
                                              : "bg-gray-100 text-gray-700"
                                          }
                                          text-sm px-5 py-0.5 rounded-full font-medium
                                        `}
                                    >
                                      {fund.response}
                                    </p>
                                  </div>
                                </td>

                                {/* <!--UPI Id--> */}
                                <td class="px-5 py-4 sm:px-6">
                                  <div class="flex items-center">
                                    <p class="text-gray-500 text-sm ">
                                      {fund.requesttype}
                                    </p>
                                  </div>
                                </td>

                                {/* <!--UPI Id--> */}
                                <td class="px-5 py-4 sm:px-6">
                                  <div class="flex items-center">
                                    <p class="text-gray-500 text-sm ">
                                      {fund.account_number}
                                    </p>
                                  </div>
                                </td>

                                {/* <!--UPI Id--> */}
                                <td class="px-5 py-4 sm:px-6">
                                  <div class="flex items-center">
                                    <p class="text-gray-500 text-sm ">
                                      {fund.account_ifsc}
                                    </p>
                                  </div>
                                </td>

                                {/* <!--UPI Id--> */}
                                <td class="px-5 py-4 sm:px-6">
                                  <div class="flex items-center">
                                    <p class="text-gray-500 text-sm ">
                                      {fund.bankname}
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="13"
                                className="text-center py-4 text-gray-500"
                              >
                                No Payout history found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* <!-- Table End --> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Payout;
